// Slow editorial marquee (CSS-driven, seamless loop).
export default function Marquee({
  items = [],
  className = "",
  itemClassName = "",
  reverse = false,
  duration = 42,
  separator = "✦",
}) {
  const loop = [...items, ...items];
  return (
    <div className={`marquee-mask overflow-hidden whitespace-nowrap ${className}`}>
      <div
        className="inline-flex items-center will-change-transform"
        style={{
          animation: `gl-marquee ${duration}s linear infinite`,
          animationDirection: reverse ? "reverse" : "normal",
        }}
      >
        {loop.map((it, i) => (
          <span key={i} className={`inline-flex items-center ${itemClassName}`}>
            <span>{it}</span>
            <span className="mx-8 md:mx-14 text-gl-gold/70 text-[0.5em] translate-y-[-0.15em]">
              {separator}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
